import lodash from 'src/utils/lodash'

export const isFunction = lodash.isFunction
